import * as React from 'react';
import { Route } from 'react-router-dom';
import { paths } from '@/config';
import { StripeCallback } from '@/components/Pages';
import enhance from './enhancer';

function StripeCallbackRoutes() {
  return (
    <Route strict path={paths.stripecallback} component={StripeCallback} />
  );
}

export default enhance((props) => <StripeCallbackRoutes {...props} />);
